import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
    root: {
        height: 300,
    },
});

function valuetext(value) {
    return `${value}°C`;
}


 

function TemperatureVal(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(30);

    const handleSliderChange = (event, newValue) => {
        
        props.getSlidbarValue(newValue)

        setValue(newValue);
    };
    const handleInputChange = (event) => {

        setValue(event.target.value === '' ? '' : Number(event.target.value));
    };
    return (
        <React.Fragment>
            <Typography id="vertical-slider" gutterBottom>
                 
            </Typography>
            <div className={classes.root}>
                <Slider
                    orientation="vertical"
                    getAriaValueText={valuetext}
                    defaultValue={10}
                    aria-labelledby="vertical-slider"
                    className="blend-slider"
                    value={props.tempVal}
                     onChange={handleSliderChange}
                     min={-273}
                     max={1000}
                />
                
            </div>
        </React.Fragment>
    );
} export default TemperatureVal;